import { CSSObject } from '@chakra-ui/react';

export const EventsClosedContainer: CSSObject = {
  py: '2',
  p: '2',
  alignItems: 'center',
  mx: -2,
  borderRadius: 'md',
};
